import { Utils } from '@gv/triage-components';

import { generateUrl } from 'utils/helpers';

import { URL } from '../constants';
import { apiInstance } from '../instance';

export const getBitwerxAvaialbleSLots = (
  hospitalId: any,
  RoomId: any,
  EndTime: any,
  StartTime: any,
  ProviderId: any
) =>
  apiInstance.get(
    Utils.Query.addParamsToUrl(
      generateUrl(URL.GET_BITWERX_AVAILABLE_SLOTS, { id: hospitalId }),
      {
        RoomId,
        EndTime,
        StartTime,
        ProviderId,
      }
    )
  );
